import React, { useEffect, useMemo, useRef, useState } from "react";
import { Modal, Checkbox, Button } from "antd";

export interface ExportableColumn {
  key: string;
  label: string;
}

interface ColumnExportModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (selectedColumns: string[]) => void;
  columns: ExportableColumn[];
  selectedColumns: string[];
  setSelectedColumns: (columns: string[]) => void; 
}

const ColumnExportModal: React.FC<ColumnExportModalProps> = ({
  open,
  onClose,
  onConfirm,
  columns,
  selectedColumns,
  setSelectedColumns,
}) => {
  const allKeys = useMemo(() => columns.map((c) => c.key), [columns]);

  const [localSelected, setLocalSelected] = useState<string[]>([]);

  const prevOpenRef = useRef<boolean>(false);
  useEffect(() => {
  if (!prevOpenRef.current && open) {
    setLocalSelected(allKeys); 
  }
  prevOpenRef.current = open;
}, [open, allKeys]);

  const handleSelectAll = () => setLocalSelected(allKeys);
  const handleClearAll = () => setLocalSelected([]);

  const handleOk = () => {
    onConfirm(localSelected);

    try { setSelectedColumns(localSelected); } catch {}
    onClose();
  };

  return (
    <Modal
      title="Select Columns to Export"
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      okButtonProps={{ disabled: localSelected.length === 0 }}
    >
      <div style={{ marginBottom: 12, display: "flex", gap: 8 }}>
        <Button
          onClick={handleSelectAll}
          disabled={localSelected.length === allKeys.length}
        >
          Add All
        </Button>
        <Button onClick={handleClearAll} disabled={localSelected.length === 0}>
          Remove All
        </Button>
      </div>

      <Checkbox.Group
        value={localSelected}
        onChange={(checkedValues) => setLocalSelected(checkedValues as string[])}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {columns.map((col) => (
            <Checkbox key={col.key} value={col.key}>
              {col.label}
            </Checkbox>
          ))}
        </div>
      </Checkbox.Group>
    </Modal>
  );
};

export default ColumnExportModal;
